<div class="box-table">
	<span class="title-accordion" [class.active]="!isCollapsed" (click)="isCollapsed = !isCollapsed"
		(keypress)="isCollapsed = !isCollapsed">
		{{ labels().APEX_TABLE_TITLE }}
		<div class="fake-material-icon icon-expand expand"></div>
	</span>
	<table class="table" [ngbCollapse]="isCollapsed">
		<thead>
			<tr>
				<th></th>
				@if (hasAP) { <th>{{ labels().APEX_TABLE_AP_HEADER }}</th> }
				@if (hasLT) { <th>{{ labels().APEX_TABLE_LT_HEADER }}</th> }
			</tr>
		</thead>
		<tbody>
			@if (isFemur || isLongLeg) {
			<tr>
				<td>{{ labels().APEX_TABLE_FEMUR }}</td>
				@if (hasAP) { <td>{{ apFemurMeasure }}</td> }
				@if (hasLT) { <td></td> }
			</tr>
			}
			@if (isTibia || isLongLeg) {
			<tr>
				<td>{{ labels().APEX_TABLE_TIBIA }}</td>
				@if (hasAP) { <td>{{ apTibiaMeasure }}</td> }
				@if (hasLT) { <td>{{ ltTibiaMeasure }}</td> }
			</tr>
			}
		</tbody>
	</table>

	<!--AXIAL ROTATION-->
	<table class="table" [ngbCollapse]="isCollapsed">
		<thead>
			<tr>
				<th colspan="2">{{ labels().APEX_TABLE_AXIAL_ROTATION_TITLE }}</th>
			</tr>
		</thead>
		<tbody>
			@if (isFemur || isLongLeg) {
			<tr>
				<td>{{ labels().APEX_TABLE_FEMUR }}</td>
				<td>{{ def_femur_axialRotation }} {{ axialRotSignLabel(def_femur_axialRotationSign) }}</td>
			</tr>
			}
			@if (isTibia || isLongLeg) {
			<tr>
				<td>{{ labels().APEX_TABLE_TIBIA }}</td>
				<td>{{ def_tibia_axialRotation }} {{ axialRotSignLabel(def_tibia_axialRotationSign) }}</td>
			</tr>
			}
		</tbody>
	</table>

</div>